import script from "./ImageSuggestionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSuggestionModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageSuggestionModal.vue?vue&type=style&index=0&id=56c24046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c24046"]])

export default __exports__